import { useState, useEffect } from "react";
import ChatMedia from "./ChatMedia";
import FileList from "./FileList";
import ChatTime from "./ChatTime";
import ChatActionsDropdown from "./ChatActionsDropdown";
import ReactionPicker from "./ReactionPicker";

const ChatContent = ({
  chat,
  chatMessages,
  index,
  activeTab,
  currentUser,
  formatDate,
  handleForwardCLick,
  deleteMessage,
  isGroup = false,
  editHandler = () => { },
  updateReactions = () => { },
  onReply = () => { },
  isGroupChat = false,
  getUserofGroupChat,
  contacts,
  activeUser
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [reactions, setReactions] = useState(chat.reactions || []);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  useEffect(() => {
    setReactions(chat.reactions || []);
  }, [chat.reactions]);

  const isSender = chat.sender === currentUser._id;
  const isImage = chat?.media?.[0]?.fileType?.startsWith("image");
  const isAudio = chat?.media?.[0]?.fileType === "audio/webm";
  const isOtherFile = chat?.media?.[0] && !isImage && !isAudio;

  const handleMouseEnter = () => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    setShowPicker(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => setShowPicker(false), 150);
    setHoverTimeout(timeout);
  };

  const handleReaction = async (emoji) => {
    let updatedReactions = [...reactions];
    const existingIndex = updatedReactions.findIndex(
      (r) => r.user === currentUser._id
    );
    if (existingIndex !== -1) {
      if (updatedReactions[existingIndex].emoji === emoji) {
        updatedReactions.splice(existingIndex, 1);
      } else {
        updatedReactions[existingIndex].emoji = emoji;
      }
    } else {
      updatedReactions.push({ user: currentUser._id, emoji });
    }
    setReactions(updatedReactions);
    updateReactions(chat, updatedReactions);
  };

  // ── Resolve the replied-to message ──
  const repliedMessage = chat.parentId
    ? chatMessages.find((m) => m._id === chat.parentId)
    : null;

  const repliedIsImage = repliedMessage?.media?.[0]?.fileType?.startsWith("image");
  const repliedIsAudio = repliedMessage?.media?.[0]?.fileType === "audio/webm";
  const repliedIsFile = repliedMessage?.media?.[0] && !repliedIsImage && !repliedIsAudio;

  console.log("chat msg", chatMessages);
  console.log("chat", chat);
  console.log("repliedMessage", repliedMessage);

  // Determine sender info depending on group or private chat
  const getSenderInfo = (senderId) => {
    const isCurrentUser = senderId === currentUser._id;

    if (isGroupChat) {
      const sender = isCurrentUser
        ? currentUser
        : getUserofGroupChat(contacts[activeUser]?.members, senderId);

      return {
        id: sender?._id,
        name: `${sender?.contactName?.first || ""} ${sender?.contactName?.last || ""
          }`.trim(),
        businessName: isCurrentUser
          ? currentUser?.accountNo?.companyInfo?.businessName
          : undefined,
        companyName: isCurrentUser
          ? currentUser?.accountNo?.companyInfo?.name
          : undefined,
        isCurrentUser,
      };
    }

    // Private chat
    const contact = contacts[activeUser];

    return {
      id: isCurrentUser ? currentUser._id : contact?._id,
      name: isCurrentUser
        ? `${currentUser?.contactName?.first || ""} ${currentUser?.contactName?.last || ""
          }`.trim()
        : contact?.name,
      businessName: isCurrentUser
        ? currentUser?.accountNo?.companyInfo?.businessName
        : contact?.businessName,
      userFunction: isCurrentUser
        ? currentUser?.function
        : contact?.function,
      companyName: isCurrentUser
        ? currentUser?.accountNo?.companyInfo?.name
        : contact?.user?.accountNo?.companyInfo?.name,
      isCurrentUser,
    };
  };

  const { name } = getSenderInfo(repliedMessage?.sender);

  return (
    <>
      {chat.isUpdated && (
        <small className="text-muted fst-italic mutedText">Edited</small>
      )}

      <div
        className="ctext-wrap position-relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className={
            chatMessages[index]?.forwardedBy
              ? "ctext-wrap-content border-start border-2 border-primary"
              : "ctext-wrap-content"
          }
        >

          {/* ── Replied message bubble ── */}
          {repliedMessage && (
            <div className={`reply-bubble text-dark mb-1 ${isSender ? "is-me" : ""}`}>
              <div className="reply-bubble-inner">
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div className={`reply-bubble-sender ${isSender ? "is-me" : ""}`}>
                    {repliedMessage?.sender === currentUser._id ? "You" : name || "Unknown"}
                  </div>

                  {repliedMessage.message && (
                    <div className={`reply-bubble-text ${isSender ? "is-me" : ""}`}>
                      {repliedMessage.message}
                    </div>
                  )}

                  {repliedIsAudio && (
                    <div className={`reply-bubble-media-label ${isSender ? "text-white-50" : "text-muted"}`}>
                      <i className="ri-mic-fill" style={{ fontSize: 12 }} />
                      Voice message
                    </div>
                  )}

                  {repliedIsFile && (
                    <div className={`reply-bubble-media-label ${isSender ? "text-white-50" : "text-muted"}`}>
                      <i className="ri-file-line" style={{ fontSize: 12 }} />
                      {repliedMessage.media[0].fileName}
                    </div>
                  )}
                </div>

                {repliedIsImage && (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${repliedMessage.media[0].filePath}`}
                    alt="reply"
                    className="reply-bubble-img"
                  />
                )}
              </div>
            </div>
          )}

          {/* ── Message text ── */}
          {chat.message && (
            <div
              className={`d-inline-block p-2 rounded ${isSender ? "bg-primary text-white" : "bg-light text-dark"
                }`}
            >
              <p className="mb-0">{chat.message}</p>
            </div>
          )}

          {/* ── Media ── */}
          {chat.media && chat.media.length > 0 && (
            <>
              {isImage ? (
                <ChatMedia media={chat.media} />
              ) : isAudio ? (
                <div>
                  <audio controls>
                    <source
                      src={`${process.env.REACT_APP_API_URL}/${chat?.media[0]?.filePath}`}
                      type="audio/webm"
                    />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              ) : (
                isOtherFile && (
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-muted">{chat?.media[0]?.fileName}</span>
                    <a
                      className="px-2"
                      href={`${process.env.REACT_APP_API_URL}/${chat?.media[0]?.filePath}`}
                      download
                    >
                      <i className="ri-download-cloud-2-line fs-5"></i>
                    </a>
                  </div>
                )
              )}
            </>
          )}

          {/* ── File message ── */}
          {chat.fileMessage && (
            <FileList fileName={chat.fileMessage} fileSize={chat.size} />
          )}
        </div>

        {/* ── Reaction picker ── */}
        {showPicker && (
          <div
            className="position-absolute left-0 ml-5"
            style={{ bottom: "100%", marginBottom: "8px", zIndex: 10 }}
          >
            <ReactionPicker onSelect={handleReaction} />
          </div>
        )}

        {/* ── Reactions display ── */}
        {reactions.length > 0 && (
          <div
            className={`position-absolute ${isSender ? "start-0" : "end-0"}`}
            style={{ bottom: "-10px", transform: "translateX(30%)", zIndex: 5 }}
          >
            <div
              className="d-flex align-items-center shadow-sm"
              style={{
                background: "#fff",
                borderRadius: "999px",
                border: "1px solid #e9ecef",
                padding: "2px 6px",
                gap: "2px",
              }}
            >
              {reactions.map((r, i) => (
                <span key={i} style={{ fontSize: "12px", lineHeight: 1 }}>
                  {r.emoji}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* ── Actions dropdown (with reply button) ── */}
        {!chat.isTyping && (
          <ChatActionsDropdown
            chat={chat}
            message={chat.message}
            handleForwardCLick={handleForwardCLick}
            chatMessages={chatMessages}
            index={index}
            deleteMessage={deleteMessage}
            isGroup={isGroup}
            currentUser={currentUser}
            editHandler={editHandler}
            onReply={() => onReply(chat)}
          />
        )}
      </div>

      <ChatTime updatedAt={chat.updatedAt} formatDate={formatDate} />
    </>
  );
};

export default ChatContent;